import { render } from "./UsedCarList.vue?vue&type=template&id=0cefd64e&scoped=true"
import script from "./UsedCarList.vue?vue&type=script&lang=js"
export * from "./UsedCarList.vue?vue&type=script&lang=js"

import "./UsedCarList.vue?vue&type=style&index=0&id=0cefd64e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cefd64e"]])

export default __exports__